import { createRoute } from '@tanstack/react-router';
import { authenticatedRoute } from '@/router/authenticated-route';
import CompanyCreatePage from '@/features/companies/company-create/CompanyCreatePage';

export const companyCreateRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/companies/create',
  component: CompanyCreatePage,
});
